module.exports = __webpack_public_path__ + "static/media/financiaciones-white.7e420aa4.svg";